/**
 * web端路由
 */
import { RouteRecordRaw } from "vue-router";

export const routesWeb: Array<RouteRecordRaw> = [
    {
        path: "/about",
        name: "About",
        component: () => import("@/views/AboutView.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/doctor",
        name: "Doctor",
        component: () => import("@/views/doctor/doctorIndex.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/doctor/detail",
        name: "DoctorDetail",
        component: () => import("@/views/doctor/DoctorDetailNew.vue"), //  @/views/doctor/DoctorDetail.vue
        meta: {
            level: 2,
        },
    },
    {
        path: "/doctor/profile",
        name: "DoctorProfile",
        component: () => import("@/views/doctor/MemberProfile.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/doctor/appoint",
        name: "DoctorAppoint",
        component: () => import("@/views/doctor/DoctorAppoint.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/doctor/vouchers",
        name: "VoucherList",
        component: () => import("@/views/user/VoucherList.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/doctor/vouchers/voucherdetail",
        name: "VoucherDetail",
        component: () => import("@/views/user/VoucherDetail.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/post",
        name: "Post",
        component: () => import("@/views/post/postIndex.vue"),
        meta: {
            level: 1,
            keepAlive: true,
        },
        children: [
            {
                path: ":id",
                name: "PostDetail",
                component: () => import("@/views/post/postDetail.vue"),
                meta: {
                    level: 2,
                    keepAlive: true,
                },
            },
        ],
    },
    {
        path: "/procedure",
        name: "Procedure",
        component: () => import("@/views/procedure/procedureIndex.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/procedure/procedureDetail",
        name: "ProcedureDetail",
        component: () => import("@/views/procedure/procedureDetailLocal.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/instrument",
        name: "Instrument",
        component: () => import("@/views/instrument/instrumentIndex.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/instrument/instrumentDetail",
        name: "InstrumentDetail",
        component: () => import("@/views/instrument/instrumentDetailLocal.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/user/detail",
        name: "UserDetail",
        component: () => import("@/views/user/UserDetail.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/user/profile",
        name: "UserProfile",
        component: () => import("@/views/doctor/MemberProfile.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/doctor/userappoints",
        name: "UserAppoint",
        component: () => import("@/views/user/appoint/Appoint.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/user/appointments",
        name: "UserAppointments",
        component: () => import("@/views/user/Appointments/index.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/user/doctorjoin",
        name: "DoctorJoinNew",
        component: () => import("@/views/doctor/DoctorJoinNew.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/user/doctorcertify",
        name: "DoctorCertify",
        component: () => import("@/views/doctor/DoctorCertify.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/user/cliniccertify",
        name: "ClinicCertify",
        component: () => import("@/views/clinic/ClinicCertify.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/contactUs",
        name: "ContactUs",
        component: () => import("@/views/other/ContactUs.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/contactUs/result",
        name: "ContactUsResult",
        component: () => import("@/views/other/ContactUsResult.vue"),
        meta: {
            level: 2,
        },
    },
    {
        path: "/valideEmail",
        name: "ValideEmailResult",
        component: () => import("@/views/other/ValideEmailResult.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/facetime",
        name: "Facetime",
        component: () => import("@/views/user/FaceTime.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/dataconsent",
        name: "DataConsentPage",
        component: () => import("@/views/other/DataConsentPage.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/termsservice",
        name: "TermsServicePage",
        component: () => import("@/views/other/TermsServicePage.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/privacypolicy",
        name: "PrivacyPolicyPage",
        component: () => import("@/views/other/PrivacyPolicyPage.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/clinic",
        name: "Clinic",
        component: () => import("@/views/clinic/clinicIndex.vue"),
        meta: {
            level: 1,
        },
    },
    {
        path: "/clinic/detail",
        name: "ClinicDetailNew",
        component: () => import("@/views/clinic/clinicDetailNew.vue"),
        meta: {
            level: 2,
        },
    },
];
